import React from 'react';
import { FaTrash } from 'react-icons/fa';
import Numbers from '~/utils/numbers';
import Dates from '~/utils/dates';
import './styles.css';

interface DeleteTeAclModalProps {
    item: { unit_id: number; year: number; month: number; price: number };
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteTeAclModal: React.FC<DeleteTeAclModalProps> = ({ item, onConfirm, onCancel }) => {
    function getMonthName(month: number) {
        month = Number(month);
        if (month===0) return 'Geral';
        return Dates._getNameMonth((month-1));
    }

    function formatPrice(value: number | string) {
        if (typeof value==='string') return Numbers.money(parseFloat(value.replace('.', '').replace(',', '.')), false, true);
        return Numbers.money(value || 0, false, true);
    }

    return (
        <div className="price-modal-container">
            <div className="price-modal-header">
                <h3>Excluir TE/ACL</h3>
            </div>

            <div className="price-modal-body">
                <div className="delete-confirmation">
                    <div className="warning-icon">
                        <FaTrash size={48} color="#dc3545" />
                    </div>
                    
                    <div className="confirmation-text">
                        <p>Deseja realmente excluir este registro de TE/ACL?</p>
                        
                        <div className="price-details">
                            <div className="detail-item">
                                <strong>Ano:</strong> {item.year}
                            </div>
                            <div className="detail-item">
                                <strong>Mês:</strong> {getMonthName(item.month)}
                            </div>
                            <div className="detail-item">
                                <strong>Montante (MWh):</strong> {formatPrice(item.price)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="price-modal-footer">
                <button className="btn-cancel" onClick={onCancel}>
                    Cancelar
                </button>
                <button className="btn-delete" onClick={onConfirm}>
                    <FaTrash size={16} />
                    Excluir
                </button>
            </div>
        </div>
    );
};

export default DeleteTeAclModal;


